module.exports = __webpack_public_path__ + "img/ch18_09_一个人的路.1aeae3dc.jpg";